import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import LandmanExpense from 'src/models/AP/LandmanExpense';

interface IViewLandmanExpensesDialogProps {
    dialogName: string;
    landmanExpenses: Array<LandmanExpense>;
    hideDialog: () => void;
}

const ViewLandmanExpensesDialog = (props: IViewLandmanExpensesDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ExcelFileDialog onCreate()');
    };

    return (
        <Dialog
            title="Expenses"
            dialogName={props.dialogName}
            isExitButtonInvisible={false}
            bodyStyle={{
                width: '40%',
                maxHeight: '60vh'
            }}
        >
            <div
                style={{
                    maxHeight: '60vh',
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse'
                    }}
                >
                    <thead>
                        <tr>
                            <th style={{ width: '10%', textAlign: 'left' }}>Created By</th>
                            <th style={{ width: '15%', textAlign: 'left' }}>Type</th>
                            <th style={{ width: '15%', textAlign: 'left' }}>Date</th>
                            <th style={{ width: '15%', textAlign: 'right' }}>Amount</th>
                            <th style={{ width: '20%', textAlign: 'left' }}>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.landmanExpenses?.map((expense, index) => (
                            <tr key={expense.id ?? index}>
                                <td
                                    style={{
                                        whiteSpace: 'nowrap', border: '1px solid lightgrey', width: '25%',
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    {expense.createdBy}
                                </td>
                                <td style={{ whiteSpace: 'nowrap', border: '1px solid lightgrey', width: '15%' }}>
                                    {expense.type}
                                </td>
                                <td style={{ whiteSpace: 'nowrap', border: '1px solid lightgrey', width: '15%' }}>
                                    {expense.date
                                        ? new Date(expense.date).toLocaleDateString()
                                        : ''}
                                </td>
                                <td
                                    style={{
                                        whiteSpace: 'nowrap', border: '1px solid lightgrey', width: '15%',
                                        textAlign: 'right'
                                    }}
                                >
                                    {expense.amount != null
                                        ? expense.amount.toLocaleString(undefined, {
                                            style: 'currency',
                                            currency: 'USD'
                                        })
                                        : ''}
                                </td>
                                <td
                                    style={{
                                        whiteSpace: 'nowrap', border: '1px solid lightgrey', width: '20%',
                                        wordBreak: 'break-word'
                                    }}
                                >
                                    {expense.description}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Dialog>
    );
};

export default ViewLandmanExpensesDialog;


// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/ViewExpensesDialog.tsx